import { issueRefundAtStatusValues } from '@/common/constants'

import { issueRefundAtStatusOptions } from './constants'

export const getOptionsByAvailableStatuses = availableStatuses => {
  if (availableStatuses) {
    return issueRefundAtStatusOptions.filter(option => {
      if (option.value === issueRefundAtStatusValues.manual) return availableStatuses.includes(null)

      return availableStatuses.includes(option.value)
    })
  }

  return issueRefundAtStatusOptions
}
